// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Form */
.dashboard-form {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  max-width: 700px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full {
  grid-column: span 2;
}

.form-label {
  font-size: 14px;
  color: #374151;
  margin-bottom: 6px;
}

.form-input {
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  font-size: 14px;
}

.form-input:focus {
  outline: none;
  border-color: #111827;
}

/* Actions */
.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.form-submit {
  padding: 10px 18px;
  background-color: #111827;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}

.form-submit:hover {
  background-color: #1f2937;
}

.form-cancel {
  padding: 10px 18px;
  background-color: #e5e7eb;
  color: #111827;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.form-cancel:hover {
  background-color: #d1d5db;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Form/style.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Form */\n.dashboard-form {\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  max-width: 700px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group.full {\n  grid-column: span 2;\n}\n\n.form-label {\n  font-size: 14px;\n  color: #374151;\n  margin-bottom: 6px;\n}\n\n.form-input {\n  padding: 10px 12px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  font-size: 14px;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #111827;\n}\n\n/* Actions */\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.form-submit {\n  padding: 10px 18px;\n  background-color: #111827;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.form-submit:hover {\n  background-color: #1f2937;\n}\n\n.form-cancel {\n  padding: 10px 18px;\n  background-color: #e5e7eb;\n  color: #111827;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.form-cancel:hover {\n  background-color: #d1d5db;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
